import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'app/angular-material/angular-material.module';
import { QuillModule } from 'ngx-quill';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DropdownDirective } from './directives/dropdown.directive';
import { DragDropDirective } from './file-upload/drag-drop.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ImageVideoPreviewComponent } from './image-video-preview/image-video-preview.component';
import { NewsItemComponent } from './news-item/news-item.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SelectBoxComponent } from './select-box/select-box.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { TablePaginationComponent } from './table-pagination/table-pagination.component';

@NgModule({
  imports: [CommonModule, AngularMaterialModule, FlexLayoutModule, FormsModule, QuillModule, RouterModule],
  declarations: [
    FileUploadComponent,
    DragDropDirective,
    SnackBarComponent,
    ConfirmDialogComponent,
    ClickOutsideDirective,
    TablePaginationComponent,
    ResetPasswordComponent,
    ImageVideoPreviewComponent,
    NewsItemComponent,
    SelectBoxComponent,
    DropdownDirective,
  ],
  exports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    AngularMaterialModule,
    FileUploadComponent,
    ClickOutsideDirective,
    TablePaginationComponent,
    ResetPasswordComponent,
    NewsItemComponent,
    SelectBoxComponent,
    DropdownDirective,
  ],
})
export class SharedModule {}
